import { isString, verify, ApiFactory } from '@tradingblock/api';
import { LoginJwtValue, UIClientTypes } from '@tradingblock/types';
import { Config } from '../config';
import jwt from 'jsonwebtoken';

type ValidTokenType = {
  value: string;
  decoded: LoginJwtValue;
};
const tryVerify = async (publicKey: string, token: string): Promise<ValidTokenType | null> => {
  try {
    var decoded = await verify(publicKey, token, {
      clientType: UIClientTypes.dashboard,
      algorithms: ['RS256'],
      ignoreExpiration: false,
    });
    if (!decoded || isString(decoded)) {
      console.warn('jwt response was invalid, an object was expected', decoded);
      return null;
    } else {
      const jwtValues = decoded as LoginJwtValue;

      return { value: token, decoded: jwtValues };
    }
  } catch (err) {
    console.warn('token verification failed:', err);
    return null;
  }
};

export const verifyToken = async (id_token: string) => {
  const pubKey = await fetch(`${Config.uiApi}/publickey`).then(res => res.json());
  return await tryVerify(pubKey.key, id_token);
};

export const extractApiTokenFromJwt = (jwtToken: string): string | null => {
  try {
    if (!jwtToken || jwtToken.split('.').length !== 3) {
      return null;
    }
    const decoded = jwt.decode(jwtToken) as any;
    return decoded && decoded.token ? decoded.token : null;
  } catch (error) {
    console.warn('Failed to extract API token from JWT:', error);
    return null;
  }
};

export const tokenCheck = async (apiToken: string): Promise<boolean> => {
  try {
    const api = ApiFactory(Config.tradingApi, apiToken);
    const response = await api.auth.checkToken();
    // Success can come as ResponseCode 0 or Payload === 'VALID'
    return response.responseCode === 0 || (typeof response.payload === 'string' && response.payload === 'VALID');
  } catch (err) {
    console.warn('TokenCheck failed:', err);
    return false;
  }
};

export const validateToken = async (id_token: string) => {
  // const pubKey = await fetch(`${Config.uiApi}/publickey`).then(res => res.json());
  const tokenResult = await fetch(`${Config.uiApi}/token`, {
    headers: { Authorization: id_token },
    credentials: 'include',
  }).then(res => res.json());
  const verifyRes = await tryVerify(tokenResult.key, tokenResult.accessToken);
  return verifyRes
    ? {
        ...verifyRes,
      }
    : undefined;
};
